import { useLanguage, useProvider } from '~/Hooks';

export const useNavigateToPartner = () => {
  const { currentLanguage } = useLanguage();
  const { currentProvider } = useProvider();
  const navigateToPartnerHub = (route = 'home') => {
    const lang = currentLanguage || 'en';
    const origin = window.location.origin;
    const partnerHubUrl = `${origin}/${lang}/${currentProvider?.domain}/${route}`;
    window.location.replace(partnerHubUrl);
  };
  return {
    navigateToPartnerHub,
  };
};
